/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueueStatusModel } from '../../models/queue-status-model';

export interface PractitionerAvailablePut$Params {
  lobbyId?: string;
}

export function practitionerAvailablePut(http: HttpClient, rootUrl: string, params?: PractitionerAvailablePut$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<QueueStatusModel>> {
  const rb = new RequestBuilder(rootUrl, practitionerAvailablePut.PATH, 'put');
  if (params) {
    rb.query('lobbyId', params.lobbyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<QueueStatusModel>;
    })
  );
}

practitionerAvailablePut.PATH = '/Practitioner/Available';
